import { Component, OnInit } from '@angular/core';
import { environment} from "../../../../../../../apps/core/src/environments/environment";
import {AuthService} from "@kodit/core/services";

@Component({
  selector: 'kodit-global-notification',
  templateUrl: './global-notification.component.html',
  styleUrls: ['./global-notification.component.scss']
})
export class GlobalNotificationComponent implements OnInit {
  /** Conditional props */
  showDugovanjeNotification : boolean = false;
  showMaintenanceNotification : boolean = false;

  constructor(
    private _authService: AuthService
  ) { }

  ngOnInit(): void {
    this._startTimerForMaintenanceCheck();
    this._shouldShowDugovanjeNotification();
    this._shouldShowMaintenanceNotification();
  }

  private _shouldShowDugovanjeNotification(){
    const todaysDate = new Date();
    const month = todaysDate.getMonth();
    const year = todaysDate.getFullYear();
    const lastDayOfMonth = new Date(year, month + 1, 0).getDate();

    this.showDugovanjeNotification =
      todaysDate.getDate() >= 25 &&
      todaysDate.getDate() <= lastDayOfMonth;
  }

  private _shouldShowMaintenanceNotification() {
    if(environment.regularMaintenance || environment.extremeMaintenance){
      localStorage.setItem('maintenanceMod','ON');
      environment.extremeMaintenance ? this.handleExtremeMaintenance() : this.showMaintenanceNotification = true; // uslovni oprenad da proverimo zbog cega smo u ifu, regular ili extremeMaintenanca
    }else{
      if(localStorage.getItem('maintenanceMod') === 'ON'){
        localStorage.removeItem('maintenanceMod');
        window.location.reload();
      }
    }
  }


  private _startTimerForMaintenanceCheck() {
    this._shouldShowMaintenanceNotification();
    window.setInterval(() => {
      this._shouldShowMaintenanceNotification();
    },environment.timerMaintenanceMs);
  }

  private handleExtremeMaintenance() {
    //moramo izlogovati trenutnog usera
    this._authService.logout();
    localStorage.setItem('maintenanceMod','ON');
  }
}
